import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Route, Routes as Switch } from "react-router-dom";
import ScrollTopBehaviour from "../components/ScrollTopBehaviour";

const Home = lazy(() => import("../views/Home"));
const NotFound = lazy(() => import("../views/NotFound"));

const Routes = () => {
    return (
        <>
            <Router>
                <ScrollTopBehaviour />
                <Suspense fallback={<div className="page-loader" aria-hidden="true" />}>
                    <Switch>
                        <Route path="/" element={<Home />} />
                        <Route path="*" element={<NotFound />} />
                    </Switch>
                </Suspense>
            </Router>
        </>
    );
};

export default Routes;
